import { useMemo } from 'react';

/**
 * 검색 쿼리에 사용될 변수를 생성하는 커스텀 훅.
 * 키워드, 필터, 정렬 값의 변경을 감지하여 변수를 메모이제이션합니다.
 * @param {string} keyword - 검색 키워드
 * @param {object} filters - 적용할 필터 객체
 * @param {string} sortValue - 정렬 순서
 * @returns {object} GraphQL 쿼리 변수
 */
const useProductSearchVariables = (keyword, filters, sortValue) => {
    return useMemo(() => {
        const filterVariables = { query: keyword };

        if (filters) {
            const {
                gender,
                subcategoryIds,
                priceMin,
                priceMax,
                brands,
                isSelling,
                condition,
            } = filters;

            if (gender) {
                filterVariables.gender = gender;
            }
            if (subcategoryIds && subcategoryIds.length > 0) {
                filterVariables.subcategory_ids = subcategoryIds;
            }
            if (priceMin !== null && priceMin !== undefined) {
                filterVariables.price_min = priceMin;
            }
            if (priceMax !== null && priceMax !== undefined) {
                filterVariables.price_max = priceMax;
            }
            if (brands && brands.length > 0) {
                filterVariables.brand = brands.map(b => (typeof b === 'string' ? b : b.name));
            }
            if (isSelling) {
                filterVariables.show_only = 'selling';
            }
            if (condition) {
                filterVariables.condition = 'NEW';
            }
        }

        return {
            filter: filterVariables,
            sort: sortValue,
        };
    }, [keyword, filters, sortValue]);
};

export default useProductSearchVariables;
